import gql from 'graphql-tag';

export const SimpleUser = gql`
  fragment SimpleUser on User {
    _id
    firstName
    lastName
    email
  }
`;

export const User = gql`
  fragment User on User {
    ...SimpleUser
    active
    role
    phone
  }
  ${SimpleUser}
`;

export const Part = gql`
  fragment Part on Part {
    _id
    mpn
    brand
    opBrand
    stock
    price1
    price100
    price500
    price1000
    currency
    noMatchMpn
    noOffers
    offers
    buyPrice
    description1
    description2
    description3
    sellPrice
    ocDescriptions
    onOcAvailable
    datasheets
    image
  }
`;
export const RowPart = gql`
  fragment RowPart on Part {
    _id
    mpn
    brand
    opBrand
    stock
    price1000
    currency
    noMatchMpn
    noOffers
    buyPrice
    sellPrice
    onOcAvailable
  }
`;



// WEBPACK FOOTER //
// ./src/qql-shared/fragments.js